<div class="video-container">
  <iframe title="Vidéo Youtube" loading="lazy" width="{{ isMobile ? widthMobile : width }}" height="{{ isMobile ? heightMobile : height }}" [src]="video | safe" (load)="getSrc()" allowfullscreen></iframe>
</div>
